<template>
  <v-card elevation="12" class="black--text pa-4" style="background: white !important; width: 100%">
    <v-card-title>
      <h2>Reset Password</h2>
    </v-card-title>
    <v-alert v-if="!code" type="warning" outlined class="mx-4">
      This reset link is missing its reset code. Please open the link from your most recent password
      reset email, or
      <router-link to="/auth/forgotPassword">request a new reset email</router-link>.
    </v-alert>
    <v-alert v-if="errorMessage" type="error" outlined class="mx-4">
      {{ errorMessage }}
    </v-alert>
    <v-form v-on:submit.prevent="resetPassword">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field id="password" label="New Password" name="password" ref="password" outlined dense
              :type="showPassword ? 'text' : 'password'" autocomplete="off" :disabled="sending || !code"
              :error-messages="errors.collect('Password')" v-validate="'required|min:8|verify_password'"
              data-vv-name="Password" required v-model="password" append-icon="mdi-eye"
              @click:append="showPassword = !showPassword"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field label="Confirm Password" :type="showPassword ? 'text' : 'password'" :disabled="sending || !code"
              outlined dense v-validate="'required|confirmed:password'" data-vv-validate-on="change"
              append-icon="mdi-eye" :error-messages="errors.collect('Confirm Password')" data-vv-name="Confirm Password"
              data-vv-as="Password" required v-model="passwordConfirmation"
              @click:append="showPassword = !showPassword"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="sending || !code" type="submit" :loading="sending" class="main-btn">
          Reset Password
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style scoped lang="scss"></style>

<script>
import Vue from 'vue';

export default {
  name: 'resetPassword',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.code = to.query.code;
    });
  },
  data() {
    return {
      showPassword: false,
      code: null,
      sending: false,
      password: null,
      passwordConfirmation: null,
      errorMessage: null,
    };
  },
  methods: {
    extractErrorMessage(err) {
      // Strapi v4 returns { error: { message, name, status, details } }
      var data = err && err.response && err.response.data;
      if (data && data.error && data.error.message) {
        return data.error.message;
      }
      if (data && data.message) {
        return typeof data.message === 'string' ? data.message : null;
      }
      return null;
    },
    async resetPassword() {
      this.errorMessage = null;
      let result;
      try {
        result = await this.$validator.validateAll();
        if (!result) {
          return result;
        }
      } catch (err) {
        return;
      }

      if (!result) {
        Vue.$eventBus.$emit('notifyUser', 'Fix the invalid fields');
        return false;
      }

      this.sending = true;

      try {
        await Vue.$userService.reset(this.password, this.passwordConfirmation, this.code);
      } catch (err) {
        this.sending = false;
        var serverMessage = this.extractErrorMessage(err);
        this.errorMessage = serverMessage
          ? 'We couldn’t reset your password: ' + serverMessage + '. The reset link may have expired — try requesting a new one from the Forgot Password page.'
          : 'We couldn’t reset your password. The reset link may have expired — try requesting a new one from the Forgot Password page.';
        return;
      }

      Vue.$eventBus.$emit('notifyUser', 'The password has been reset');

      this.$router.push('/auth/login');
    }
  }
};
</script>
